import { render, staticRenderFns } from "./RecommendTag.vue?vue&type=template&id=30c4795f&scoped=true"
import script from "./RecommendTag.vue?vue&type=script&lang=js"
export * from "./RecommendTag.vue?vue&type=script&lang=js"
import style0 from "./RecommendTag.vue?vue&type=style&index=0&id=30c4795f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4795f",
  null
  
)

export default component.exports